import React from 'react';
import Input from './input';

class CurrencyInput extends React.Component {
  state = {
    isEditing: false,
  };

  formatCurrency = (value) => {
    if (value === null || value === undefined) return '';
    const numericValue = parseFloat(value);
    return `₦${numericValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  };

  handleFocus = () => {
    this.setState({ isEditing: true });
  };

  handleBlur = (e) => {
    const { name, onChange } = this.props;
    const rawValue = e.target.value.replace(/[^0-9.]/g, '');
    let numericValue = parseFloat(rawValue);
    
    if (!isNaN(numericValue)) {
      numericValue = numericValue.toFixed(2);
      onChange({ currentTarget: { name, value: numericValue } });
    } else {
      onChange({ currentTarget: { name, value: '' } });
    }
    
    this.setState({ isEditing: false });
  };

  handleChange = (e) => {
    const { name, onChange } = this.props;
    const rawValue = e.target.value.replace(/[^0-9.]/g, '');
    onChange({ currentTarget: { name, value: rawValue } });
  };

  render() {
    const { name, label, value, disabled, error, comment, helpText } = this.props;
    const { isEditing } = this.state;

    return (
      <Input
        type="text"
        name={name}
        value={isEditing ? value : this.formatCurrency(value)}
        label={label}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        error={error}
        disabled={disabled}
        comment={comment}
        helpText={helpText}
      />
    );
  }
}

export default CurrencyInput;
